module.exports = __webpack_public_path__ + "media/images/ready/icon-smileys-6d0aad7411ed814cdd36e78a360ca30a.svg";